import * as React from 'react';
import { CredentialSecret } from '../../../../types';
import { useTrashablePromise } from '../../../../hooks';
import { apiRawFetch } from '../../../../APIClient';

// TODO: integrate with useLazyAuthQuery some day

export const useFetchCredential = (uuid: string) => {
  const [credential, setCredential] = React.useState<CredentialSecret | null>(
    null,
  );
  const [isLoading, setIsLoading] = React.useState(false);
  const [error, setError] = React.useState<any>(null);

  const { registerPromise } = useTrashablePromise();

  React.useEffect(() => {
    const fetchCredential = async () => {
      setError(null);
      setIsLoading(true);
      try {
        const { credential } = await registerPromise(
          apiRawFetch.getCredential(uuid),
        );
        setCredential(credential);
        setIsLoading(false);
      } catch (error) {
        setError(error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCredential();
  }, [registerPromise, uuid]);

  return {
    error,
    isLoading,
    credential,
  };
};
